import {getAssetPath} from "../../../../../../utils/get-asset-path.js";

const GarrisonTimelineIcon = ({i}) => {

  const icon = getAssetPath("/img/garrison-timeline/icon.svg")
  return(
    <div className="relative h-10 w-10 shrink-0">
      <img src={icon} className="w-full h-full block" alt="Ícone de Guarnição" />
      <div className="absolute top-1/2 left-1/2 h-5 w-5 -translate-x-1/2 -translate-y-1/2 rounded-full text-white flex items-center justify-center text-[12px] leading-none font-bold">
        {i ?? ""}
      </div>
    </div>
  );
}

export default GarrisonTimelineIcon;